const Dictionary = {
    nb: {
        aktiver: 'Aktiver',
        aktiverBankId: 'Aktiver BankID',

        bankId: 'BankID',
        bankIdAvtale: 'BankID avtale',
        bankIdAvtaleAktivering: 'Aktivering',
        bankIdAvtaleGodtarVilkaar: 'Jeg har lest og akseptert avtalevilkårene.',
        bankIdAvtaleIngenAktivering: 'Du har ingen bankId avtale som skal aktiveres',
        bankIdAvtaleLoggetInn: 'Du er innlogget.',
        bankIdAvtalePassordAktivert: 'Din aktivereing er godkjent.',
        bankIdAvtalePassordBeskrivelse: 'For å inngå BankID avtale må du ha kode og passord. Koden får du fra kodebrikken som du har fått i posten. Hvis du ikke har fått passord, kan du bestille det på SMS. Passordet sendes til nummeret vi har registrert på deg.',
        bankIdAvtalePassordBestilling: 'Passord bestilling',
        bankIdAvtalePassordBestillingFattPassord: 'Jeg har allerede fått passord i posten og trenger ikka passord på SMS',
        bankIdAvtalePassordBestillingKodePakrevd: 'Vennligst legg inn kode fra kodebrikke for å bestille passord på SMS',
        bankIdAvtalePassordBestillingSMS: 'Send meg passord på SMS',
        bankIdAvtalePassordTittel: 'Bestill passord',
        bankidAvtalePassordRegistrertNummer: 'Nummeret vi har registrert på deg er: ',
        bankIdAvtaleSendPassordPaSMS: 'Send passord på SMS',
        bankIdAvtaleSendPassordPaSMSerSendt: 'Passordet er sendt til {}',
        bankIdAvtaleSluttBeskrivelse1: 'Avtalen blir nå aktivert. Ved første gangs bruk skal du bruke samme passord som du fikk tilsendt og som du brukte da du godkjente avtalen. Du vil da bli bedt om å sette personlig passord. Dette skal du ikke dele med noen.',
        bankIdAvtaleSluttBeskrivelse2: 'Logg inn i nettbanken slik at du får satt ditt personlige passord!',
        bankIdAvtaleSluttTittel: 'Bekreftelse på BankID avtale',
        bankIdAvtaleVilkar: 'BankID avtalevilkår',
        bankIdAvtaleVilkarPDF: 'BankID avtalevilkår PDF',
        lastNedBankIdAvtaleVilkarPDF: 'Last ned BankID avtalevilkår PDF',
        bankIdBeskrivelse: 'Bruk BankID-app eller kodebrikke sammen med passordet ditt.',
        bankIdPaMobil: 'BankID på mobil',
        bankIdPaMobilBeskrivelse: 'Logg deg på med mobilen. BankID på mobil må aktiveres i nettbanken før du kan ta det i bruk.',

        bestill: 'Bestill',
        errorOPTvalideringsfeil: 'OTP valideringsfeil.',
        ferdig: 'Ferdig',
        fnr: 'Fødselsnummer',
        fnrError: 'Fødselsnummer er ugyldig. Legg inn ditt fødselsnummer (11 siffer)',
        fnrPakrevd: 'Legg inn ditt fødselsnummer (11 siffer)',
        forsideBeskrivelse1:'Her kan du aktivere din BankID med brikke og passord. Ved aktivering inngår du BankID-avtalen som regulerer bruken av BankID. For å inngå avtalen og aktivere BankID må du ha kode og passord. Koden får du fra kodebrikken som du har fått i posten, mens midlertidig passord får du på SMS underveis.',
        forsideBeskrivelse2:'NB: Hvis du kun skal ha BankID-app aktiverer du i appen og setter samtidig passord der.',
        kodebrikke: 'Kode fra kodebrikke',
        kodebrikkeError: 'Kode er ugyldig. Legg inn kode fra kodebrikken (6 siffer)',
        kodebrikkePakrevd: 'Legg inn kode fra kodebrikken (6 siffer)',
        loggInn: 'Logg inn',
        mobilnummer: 'Mobilnummer',
        mobilnummerError: 'Mobilnummer er ugyldig',
        mobilnummerPakrevd: 'Vennligst legg inn mobilnummer på åttesifret',
        neste: 'Neste',
        nettbankPalogging: 'Nettbank Pålogging',
        opsNoeGikkGalt: 'Ops! Noe gikk galt',
        passord: 'Passord',
        passordError: 'Passord er ugyldig',
        passordPakrevd: 'Vennligst legg inn passord',
        skjulDetaljer: 'Skjul detaljer',
        skjulPassord: 'Skjul passord',
        start: 'Start',
        startPaaNytt: 'Start på nytt',
        visDetaljer: 'Vis detaljer',
        visMer: 'Vis mer',
        visMindre: 'Vis mindre',
        visPassord: 'Vis passord',

        /** BankId INFO **************************************/
        bankIdInfoBank: 'Bankforbindelse',
        bankIdInfoDag: 'Dag',
        bankIdInfoDager: 'Dager',
        bankIdInfoElementer: 'Sikkerhetselementer',
        bankIdInfoEmne: 'Utstedt til',
        bankIdInfoEndret: 'Oppdatert',
        bankIdInfoGyldig: 'Gyldig',
        bankIdInfoGyldigFra: 'Gyldig fra',
        bankIdInfoGyldigTil: 'Gyldig til',
        bankIdInfoImorgen: 'i morgen',
        bankIdInfoMobil: 'Mobilnummer',
        bankIdInfoRegistrert: 'Opprettet',
        bankIdInfoStatus: 'Status',
        bankIdInfoTittel: 'Min BankID',
        bankIdInfoTomt: 'Du har ingen BankID registrert hos oss.',
        bankIdInfoType: 'Type',
        bankIdInfoUtloper: 'BankId utløper om {} {}',
        bankIdInfoUtsteder: 'Utstedt av',

        /** ENUM **************************************/

        ACTIVATION_STARTED: 'Startet aktivering',
        NO_BANKID_OR_OTP_VERIFICATION_FAILED: 'Kan ikke starte aktivering. Inntastet kode er feil, eller du har ingen BankID som skal aktiveres. Kontakt kundeservice hvis du mener dette er feil.',
        CONTACT_DETAILS_CONVERSION_PERIOD: "Kan ikke starte aktivering. Det er mindre enn 24 timer siden du sist endret mobilnummer eller epost-adresse.",
        ORDER_ACTIVATED: 'Ordre er aktivert',
        OTP_VERIFICATION_TIMEOUT: 'Aktiveringen er utløpt, du må starte prosessen på nytt',
        PASSWORD_SENT: 'Passordet er sendt',
        PWD_TOO_MANY_ATTEMPTS: 'Feil passord er skrevet inn for mange ganger',
        WRONG_PASSWORD: 'Feil passord',
    },
    nn: {
        aktiver: 'Aktiver',
        aktiverBankId: 'Aktiver BankID',

        bankId: 'BankID',
        bankIdAvtale: 'BankID avtale',
        bankIdAvtaleAktivering: 'Aktivering',
        bankIdAvtaleGodtarVilkaar: 'Jeg har lest og akseptert avtalevilkårene.',
        bankIdAvtaleIngenAktivering: 'Du har ingen bankId avtale som skal aktiveres',
        bankIdAvtaleLoggetInn: 'Du er innlogget.',
        bankIdAvtalePassordAktivert: 'Din aktivereing er godkjent.',
        bankIdAvtalePassordBeskrivelse: 'For å inngå BankID avtale må du ha kode og passord. Koden får du fra kodebrikken som du har fått i posten. Hvis du ikke har fått passord, kan du bestille det på SMS. Passordet sendes til nummeret vi har registrert på deg.',
        bankIdAvtalePassordBestilling: 'Passord bestilling',
        bankIdAvtalePassordBestillingFattPassord: 'Jeg har allerede fått passord i posten og trenger ikka passord på SMS',
        bankIdAvtalePassordBestillingKodePakrevd: 'Vennligst legg inn kode fra kodebrikke for å bestille passord på SMS',
        bankIdAvtalePassordBestillingSMS: 'Send meg passord på SMS',
        bankIdAvtalePassordTittel: 'Bestill passord',
        bankidAvtalePassordRegistrertNummer: 'Nummeret vi har registrert på deg er: ',
        bankIdAvtaleSendPassordPaSMS: 'Send passord på SMS',
        bankIdAvtaleSendPassordPaSMSerSendt: 'Passordet er sendt til {}',
        bankIdAvtaleSluttBeskrivelse1: 'Avtalen blir nå aktivert. Ved første gangs bruk skal du bruke samme passord som du fikk tilsendt og som du brukte da du godkjente avtalen. Du vil da bli bedt om å sette personlig passord. Dette skal du ikke dele med noen.',
        bankIdAvtaleSluttBeskrivelse2: 'Logg inn i nettbanken slik at du får satt ditt personlige passord!',
        bankIdAvtaleSluttTittel: 'Bekreftelse på BankID avtale',
        bankIdAvtaleVilkar: 'BankID avtalevilkår',
        bankIdAvtaleVilkarPDF: 'BankID avtalevilkår PDF',
        lastNedBankIdAvtaleVilkarPDF: 'Last ned BankID avtalevilkår PDF',
        bankIdBeskrivelse: 'Bruk BankID-app eller kodebrikke sammen med passordet ditt.',
        bankIdPaMobil: 'BankID på mobil',
        bankIdPaMobilBeskrivelse: 'Logg deg på med mobilen. BankID på mobil må aktiveres i nettbanken før du kan ta det i bruk.',

        bestill: 'Bestill',
        errorOPTvalideringsfeil: 'OTP valideringsfeil.',
        ferdig: 'Ferdig',
        fnr: 'Fødselsnummer',
        fnrError: 'Fødselsnummer er ugyldig. Legg inn ditt fødselsnummer (11 siffer)',
        fnrPakrevd: 'Legg inn ditt fødselsnummer (11 siffer)',
        forsideBeskrivelse1:'Her kan du aktivere din BankID med brikke og passord. Ved aktivering inngår du BankID-avtalen som regulerer bruken av BankID. For å inngå avtalen og aktivere BankID må du ha kode og passord. Koden får du fra kodebrikken som du har fått i posten, mens midlertidig passord får du på SMS underveis.',
        forsideBeskrivelse2:'NB: Hvis du kun skal ha BankID-app aktiverer du i appen og setter samtidig passord der.',
        kodebrikke: 'Kode fra kodebrikke',
        kodebrikkeError: 'Kode er ugyldig. Legg inn kode fra kodebrikken (6 siffer)',
        kodebrikkePakrevd: 'Legg inn kode fra kodebrikken (6 siffer)',
        loggInn: 'Logg inn',
        mobilnummer: 'Mobilnummer',
        mobilnummerError: 'Mobilnummer er ugyldig',
        mobilnummerPakrevd: 'Vennligst legg inn mobilnummer på åttesifret',
        neste: 'Neste',
        nettbankPalogging: 'Nettbank Pålogging',
        opsNoeGikkGalt: 'Ops! Noe gikk galt',
        passord: 'Passord',
        passordError: 'Passord er ugyldig',
        passordPakrevd: 'Vennligst legg inn passord',
        skjulDetaljer: 'Skjul detaljer',
        skjulPassord: 'Skjul passord',
        start: 'Start',
        startPaaNytt: 'Start på nytt',
        visDetaljer: 'Vis detaljer',
        visMer: 'Vis mer',
        visMindre: 'Vis mindre',
        visPassord: 'Vis passord',

        /** BankId INFO **************************************/
        bankIdInfoBank: 'Bankforbindelse',
        bankIdInfoDag: 'Dag',
        bankIdInfoDager: 'Dager',
        bankIdInfoElementer: 'Sikkerhetselementer',
        bankIdInfoEmne: 'Utstedt til',
        bankIdInfoEndret: 'Oppdatert',
        bankIdInfoGyldig: 'Gyldig',
        bankIdInfoGyldigFra: 'Gyldig fra',
        bankIdInfoGyldigTil: 'Gyldig til',
        bankIdInfoImorgen: 'i morgen',
        bankIdInfoMobil: 'Mobilnummer',
        bankIdInfoRegistrert: 'Opprettet',
        bankIdInfoStatus: 'Status',
        bankIdInfoTittel: 'Min BankID',
        bankIdInfoTomt: 'Du har ingen BankID registrert hos oss.',
        bankIdInfoType: 'Type',
        bankIdInfoUtloper: 'BankId utløper om {} {}',
        bankIdInfoUtsteder: 'Utstedt av',

        /** ENUM **************************************/

        ACTIVATION_STARTED: 'Startet aktivering',
        NO_BANKID_OR_OTP_VERIFICATION_FAILED: 'Kan ikke starte aktivering. Inntastet kode er feil, eller du har ingen BankID som skal aktiveres. Kontakt kundeservice hvis du mener dette er feil.',
        CONTACT_DETAILS_CONVERSION_PERIOD: "Kan ikke starte aktivering. Det er mindre enn 24 timer siden du sist endret mobilnummer eller epost-adresse.",
        ORDER_ACTIVATED: 'Ordre er aktivert',
        OTP_VERIFICATION_TIMEOUT: 'Aktiveringen er utløpt, du må starte prosessen på nytt',
        PASSWORD_SENT: 'Passordet er sendt',
        PWD_TOO_MANY_ATTEMPTS: 'Feil passord er skrevet inn for mange ganger',
        WRONG_PASSWORD: 'Feil passord',
    }
};
export default Dictionary;
